module.exports = __webpack_public_path__ + "media/images/drapeau-belge-001aa626698d72d7131fa2ebda4a5b13.jpg";